import axios from 'axios';

// Called directly from the browser per product decision — this key is visible
// in the built JS bundle to anyone who inspects it.
const TWELVELABS_API_KEY = 'tlk_1KZ65W70ERAJA421N3DB409ZN3FE';
const TWELVELABS_BASE_URL = 'https://api.twelvelabs.io/v1.3';

// TwelveLabs error responses are typically { code, message }, but fall back
// through a few other common shapes (and the raw axios error) so callers
// always get something readable to show the user instead of a generic string.
export function extractApiErrorMessage(err, fallback = 'Something went wrong.') {
    const data = err?.response?.data;
    if (typeof data === 'string' && data.trim()) return data;
    const msg = data?.message || data?.error?.message || data?.error || data?.detail;
    if (typeof msg === 'string' && msg.trim()) return msg;
    if (typeof err?.message === 'string' && err.message.trim()) return err.message;
    return fallback;
}

export function resolveTwelveLabsIds(item) {
    const indexId = item?.indexId || item?.index_id || item?.userMetadata?.indexId || item?.userMetadata?.index_id;
    const videoId = item?.videoId || item?.video_id;
    return { indexId, videoId };
}

export async function fetchTwelveLabsVideo(indexId, videoId) {
    if (!indexId || !videoId) return null;
    const response = await axios.get(
        `${TWELVELABS_BASE_URL}/indexes/${indexId}/videos/${videoId}`,
        {
            headers: { 'x-api-key': TWELVELABS_API_KEY },
            params: { transcription: true },
        }
    );
    return response.data;
}

export async function fetchTwelveLabsEntities({ name = '', status = 'ready', page = 1 } = {}) {
    const response = await axios.get(`${TWELVELABS_BASE_URL}/entities`, {
        headers: { 'x-api-key': TWELVELABS_API_KEY },
        params: { name, status, page },
    });
    const data = response.data;
    const list = data?.data || data?.entities || (Array.isArray(data) ? data : []);
    return { list, pageInfo: data?.page_info || data?.pageInfo || null };
}

